export const selectPortal = (state) => state.app.portal;

export const selectFlashMessage = (state) => state.app.flashMessage;
